import { Session } from '@ais-ui/auth';

export const selectMessageTargets = async (
  session: Session,
  senderMmsi: number,
  receiverMmsi: number
) => {
  const response = await session.request('selectMessageTargets', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
    senderMmsi: senderMmsi,
    receiverMmsi: receiverMmsi,
  });

  return response;
};
